import { APIError } from '../../../../../utils'

export const isFecImportNotFoundError = (error: unknown): error is APIError =>
  error instanceof APIError && error.statusCode === 404
